
export function styles() {
    return {
        position: "absolute" as 'absolute',
        borderLeft: "0.2em solid red",
        minHeight: "100%",
        pointerEvents: "none" as 'none'
    }
}